<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <div class="page_header">
      <h4 translate class="m-0 page_header_title">Stream List</h4>
    </div>
    <div *ngIf="actiondata?.create">
      <button translate mat-raised-button color="primary" (click)="openAddStreamDialog()" class="px-4 add_button">+ Add
        Streams</button>
    </div>
  </div>
  <ng-container *ngIf="actiondata?.list_view">
    <div class="mt-2 table-container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="stream_name">
          <th translate mat-header-cell *matHeaderCellDef>Stream Name</th>
          <td mat-cell *matCellDef="let element"> {{element.stream_name}} </td>
        </ng-container>
        <ng-container matColumnDef="category_name">
          <th translate mat-header-cell *matHeaderCellDef>Category Name</th>
          <td mat-cell *matCellDef="let element"> {{element.category_name}} </td>
        </ng-container>
        <ng-container matColumnDef="start_date">
          <th translate mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let element"> {{element.start_date}} </td>
        </ng-container>
        <ng-container matColumnDef="end_date">
          <th translate mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let element"> {{element.end_date}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th translate mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <!-- <button mat-raised-button (click)="showsemesterdetails(row)">View</button> -->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
        </tr>
        <tr class="mat-row" *matNoDataRow>
          <td translate class="mat-cell" colspan="4">No data</td>
        </tr>
      </table>
      <div class="mt-2" *ngIf="total_count > 5">
        <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
      </div>
    </div>
  </ng-container>
</section>